import _ from 'lodash';

const filterOnScenario = (row, scenario) => {
    return row.scenario === scenario;
}

export const getScenarios = (rows) => {
    rows = rows.map((row) => row.scenario)
    return _.uniq(rows, (row) => row.scenario);
}

export const transformDataIntoGroups = (config) => {
    const {data, groups, groupLabels, isGroupMember, showNrOfRowsInLabel} = config;
    const scenarios = getScenarios(data.rows);
    return {
        data: {
            labels: groupLabels ? groupLabels : groups,
            datasets: _.concat(
                scenarios.map((scenario) => {
                    const scenarioRows = data.rows.filter((row) => filterOnScenario(row, scenario));
                    return {
                        label: showNrOfRowsInLabel ? `${scenarioRows.length} videos` : '',
                        backgroundColor: "#083E58",
                        data: groups.map((group) => scenarioRows
                            .filter((row) => isGroupMember(group, row))
                            .length
                        )
                    }
                })
            )
        },
        options: {
            // Only display (rounded) int on yAxes.
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: (value) => value % 1 === 0 ? value : null
                    }
                }]
            },
            plugins: {
                legend: {
                    display: true,
                },
            },
        }
    };
}